export default __webpack_public_path__ + "static/media/Graph Setting.cb6c1270.svg";